import React from 'react';

import { useConfig } from '../../defaultConfig';
import { GroupedAccountsOverview, SingleAccountsOverview } from './components';

import './AccountOverview.scss';

function AccountOverviewApp() {
    const { featureToggles } = useConfig();
    if (!featureToggles.enableAccountsDnd) {
        return <SingleAccountsOverview />;
    }

    return <GroupedAccountsOverview />;
}

export default AccountOverviewApp;
